import gql from 'graphql-tag'

const HOTSITE_CONFIGURATION_FIELDS_FRAGMENT = gql`
  fragment HotsiteConfigurationFields on HotsiteConfiguration {
    _id
    mode
    version
    created_by {
      _id
      login
    }
    created_at
    overrides {
      facebook_pixel_id
      google_analytics_id
      signup_tag
    }
    settings {
      assets {
        positions {
          formImage
        }
        images {
          home {
            desktop
            tablet
            smartphone
          }
          form {
            desktop
            tablet
            smartphone
          }
          finish {
            desktop
            tablet
            smartphone
            logo
          }
        }
        colors {
          home {
            background
            buttonBackground
            buttonFont
            input
          }
          form {
            buttonBackground
            buttonFont
            toolbar
          }
          finish {
            background
            buttonBackground
            buttonFont
            text
            main
          }
          legalFooter {
            background
            font
          }
          socialNetworksFooter {
            background
            font
          }
        }
      }
      fields {
        allowed_person_types_signup
        natural {
          name
          type
          width
          label
          options {
            label
            value
          }
          mask
          placeholder
          validators
          backend
          mandatory
        }
        legal {
          name
          type
          width
          label
          options {
            label
            value
          }
          mask
          placeholder
          validators
          backend
          mandatory
        }
      }
    }
  }
`

export const HOTSITE_SIGNUP_CONFIGURATION_INPUT = gql`
  query Account {
    account {
      loyalty_club_name
      channels {
        hotsite {
          configuration {
            facebook_pixel_id
            google_analytics_id
            allowed_countries
            email_required
            password_visible
            fields {
              natural {
                type
                name
                validators
                visible
                mandatory
              }
              legal {
                type
                name
                validators
                visible
                mandatory
              }
            }
          }
        }
      }
    }
  }
`

export const HOTSITE_CONFIGURATION = gql`
  query Configuration {
    configuration {
      contacts {
        phones
        emails
        whatsapp
      }
      hotsite_links {
        name
        url
      }
      password_recovery_channels {
        sms
        email
      }
      enable_delete_data_requests
      enable_delete_partial_data_requests
      enable_whatsapp_link
      enable_apps
      whatsapp_link
    }
  }
`

export const UPDATE_HOTSITE_SIGNUP_CONFIGURATION = gql`
  mutation UpdateHotsiteCustomerConfiguration(
    $passwordVisible: Boolean!
    $emailRequired: Boolean!
    $pixelId: String
    $allowedCountries: [AllowedCountries!]!
    $googleAnalyticsId: String
    $phones: [String!]!
    $emails: [String!]!
    $whatsapp: [String!]!
    $recoverPasswordWithEmail: Boolean!
    $recoverPasswordWithSms: Boolean!
    $loyaltyClubName: String
    $enableDeleteDataRequests: Boolean!
    $enableDeletePartialDataRequests: Boolean!
    $hotsite_links: [HotsiteConfigurationLinksInput]
    $enable_apps: Boolean!
    $enable_whatsapp_link: Boolean!
    $whatsapp_link: String
  ) {
    updateHotsiteCustomerConfiguration {
      updateSignupConfiguration(configuration: { password_visible: $passwordVisible, email_required: $emailRequired })
      updateFacebookPixelId(pixel_id: $pixelId)
      updateAllowedCountries(allowed_countries: $allowedCountries)
      updateGoogleAnalyticsId(google_analytics_id: $googleAnalyticsId)
      updateContactInfo(info: { phones: $phones, emails: $emails, whatsapp: $whatsapp })
      updatePasswordRecoveryChannels(password_recovery_channels: { sms: $recoverPasswordWithSms, email: $recoverPasswordWithEmail })
      updateLoyaltyClubName(loyalty_club_name: $loyaltyClubName)
      updateDeleteDataRequestsConfiguration(enable_delete_data_requests: $enableDeleteDataRequests)
      updateDeletePartialDataRequestsConfiguration(enable_delete_partial_data_requests: $enableDeletePartialDataRequests)
      upsertHotsiteConfiguration(hotsite_links: $hotsite_links)
      updateAppsConfiguration(enable_apps: $enable_apps)
      updateEnableWhatsappLink(enable_whatsapp_link: $enable_whatsapp_link)
      updateWhatsappLink(whatsapp_link: $whatsapp_link)
    }
  }
`

export const PASSWORD_RECOVERY_BALANCE = gql`
  query PasswordRecoveryBalance {
    passwordRecoveryBalance(mode: SMS)
  }
`

export const LIST_HOTSITE_SLOTS = gql`
  query HotsiteSlots($page: Int, $pageSize: Int, $sortDirection: [SortDirection], $sort: [String], $search: String) {
    hotsiteSlots(page: $page, pageSize: $pageSize, sortDirection: $sortDirection, sort: $sort, search: $search) {
      page
      records
      slots {
        _id
        name
        urls
        latest_version
      }
    }
  }
`

export const HOTSITE_SLOT = gql`
  query HotsiteSlot($id: ID!) {
    hotsiteSlot(id: $id) {
      _id
      name
      urls
      production_configuration {
        ...HotsiteConfigurationFields
      }
      preview_configuration {
        ...HotsiteConfigurationFields
      }
    }
  }
  ${HOTSITE_CONFIGURATION_FIELDS_FRAGMENT}
`

export const LIST_HOTSITE_CONFIGURATIONS_FOR_SLOT = gql`
  query HotsiteConfigurations($hotsiteSlotId: ID!, $page: Int!, $pageSize: Int!, $sortDirection: [SortDirection], $sort: [String]) {
    hotsiteConfigurations(hotsiteSlotId: $hotsiteSlotId, page: $page, pageSize: $pageSize, sortDirection: $sortDirection, sort: $sort) {
      records
      page
      hotsiteConfigurations {
        ...HotsiteConfigurationFields
      }
    }
  }
  ${HOTSITE_CONFIGURATION_FIELDS_FRAGMENT}
`

export const SAVE_HOTSITE_SLOT_PREVIEW = gql`
  mutation SetPreviewHotsiteConfiguration($hotsiteSlotId: ID!, $settings: HotsiteConfigurationSettingsInput!, $overrides: HotsiteConfigurationOverridesInput) {
    setPreviewHotsiteConfiguration(hotsiteSlotId: $hotsiteSlotId, settings: $settings, overrides: $overrides) {
      _id
    }
  }
`

export const SAVE_HOTSITE_SLOT_PRODUCTION = gql`
  mutation SetProductionHotsiteConfiguration(
    $hotsiteSlotId: ID!
    $settings: HotsiteConfigurationSettingsInput!
    $overrides: HotsiteConfigurationOverridesInput
  ) {
    setProductionHotsiteConfiguration(hotsiteSlotId: $hotsiteSlotId, settings: $settings, overrides: $overrides) {
      _id
    }
  }
`

export const SAVE_HOTSITE_PRODUCTION_URLS = gql`
  mutation SetHotsiteSlotUrls($hotsiteSlotId: ID!, $urls: [String]!) {
    setHotsiteSlotUrls(hotsiteSlotId: $hotsiteSlotId, urls: $urls) {
      _id
    }
  }
`

export const ADD_HOTSITE_SLOT = gql`
  mutation AddHotsiteSlot($name: String!) {
    addHotsiteSlot(name: $name) {
      _id
    }
  }
`
